import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InjectMenuItem from './MenuItem';
import has from 'lodash/has';
import { Box, Menu as NBMenu, Pressable } from "native-base";

import { Sortable } from '~/native-ui/sortable/Sortable';

const POSITION = {
  AUTO: 'auto',
  STATIC: 'static',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
};

const MENU_HEIGHT_AUTO = 'auto';
const MENU_OFFSET_FROM_EDGE = 30;

const factory = (MenuItem) => {
  class Menu extends Component {
    static propTypes = {
      orderable: PropTypes.bool,
      onReorder: PropTypes.func,
      config: PropTypes.object,
      closeOnSelect: PropTypes.bool,
      children: PropTypes.node,
      className: PropTypes.string,
      onClose: PropTypes.func,
      onSelect: PropTypes.func,
      onShow: PropTypes.func,
      outline: PropTypes.bool,
      position: PropTypes.oneOf(Object.keys(POSITION).map(key => POSITION[key])),
      ripple: PropTypes.bool,
      selectable: PropTypes.bool,
      selected: PropTypes.node,
      trigger: PropTypes.func,
      theme: PropTypes.shape({
        active: PropTypes.string,
        bottomLeft: PropTypes.string,
        bottomRight: PropTypes.string,
        menu: PropTypes.string,
        menuInner: PropTypes.string,
        outline: PropTypes.string,
        rippled: PropTypes.string,
        static: PropTypes.string,
        topLeft: PropTypes.string,
        topRight: PropTypes.string,
      }),
    };

    static defaultProps = {
      outline: true,
      position: POSITION.STATIC,
      closeOnSelect: true,
      ripple: true,
      selectable: true,
    };

    state = {
      rippled: false,
    };

    get canReorder() {
      return !!this.props.orderable && !!this.props.onReorder
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.children.length === 0) {
        return;
      }

      if (this.props.children[0] && nextProps.children[0] && this.props.children[0].length !== nextProps.children[0].length) {
        this.setState({ height: MENU_HEIGHT_AUTO });
      }
    }


    handleSelect = (item, event) => {

      const { value, onClick } = item.props;
      if (onClick) event.persist();
      this.setState({ active: !this.props.closeOnSelect, rippled: this.props.ripple }, () => {
        if (onClick) onClick(event);
        if (this.props.onSelect) this.props.onSelect(value);
      });
    };



    renderItems() {
      return React.Children.map(this.props.children, (item, index) => {
        if (!item) return item;

        // only MenuItem has caption prop
        if (item.type.name === MenuItem.name) {
          return React.cloneElement(item, {
            index,
            orderable: has(item.props, "orderable") ? item.props.orderable : this.canReorder,
            selected: typeof item.props.value !== 'undefined'
              && this.props.selectable
              && item.props.value === this.props.selected,
            onClick: this.handleSelect.bind(this, item),
          });
        }

        return React.cloneElement(item);
      });
    }

    onOverlayClick = () => {
      this.setState({ active: false, rippled: false });
    }

    setMenuNode(node) {
      const calculateDimensions = this.menuNode === undefined;
      this.menuNode = node;

      // if (calculateDimensions) {
      //   this.show();
      // }
    }

    onReorder = (oldIndex, newIndex) => {
      this.props.onReorder(oldIndex, newIndex)
    }

    getMenuDragContainer = () => {
      return this.menuNode?.parentNode
    }

    getHelperContainer = () => {
      return this.menuNode?.parentNode
    }

    trigger = (triggerProps) => {
        const trigger = this.props.trigger?.(triggerProps) || null;

        
        if (!trigger) {
            return null;
        }

        return <Pressable { ...triggerProps }>{ trigger }</Pressable>
    }

    onOpen = () => {
      this.props.onOpen?.()
    }

    onClose = () => {
      this.props.onClose?.()
    }


    renderMenu() {
      return (
        <NBMenu
          isOpen={this.props.isOpen ?? undefined}
          shouldFlip
          maxHeight="49vh"
          trigger={ this.trigger }
          onOpen={this.onOpen}
          onClose={this.onClose}
          onKeyDown={this.props.onKeyDown}
          closeOnSelect={ this.props.closeOnSelect }
          shouldOverlapWithTrigger={this.props.shouldOverlapWithTrigger}
        >
          {this.renderMaybeDraggableMenu()}
        </NBMenu>
      )
    }

    renderMaybeDraggableMenu() {
      return !this.canReorder
        ? this.renderItems()
        : (
            <Sortable
              useDragHandle
              getContainer={this.getMenuDragContainer}
              onSortEnd={this.onReorder}
              lockToContainerEdges={true}
              axis="y"
              lockAxis="y"
            >
              <Box ref={(node) => { this.setMenuNode(node) }}>
                {this.renderItems()}
              </Box>
            </Sortable>
        )
    }

    render() {
      return this.renderMenu();
    }
  }

  return Menu;
};

const Menu = factory(InjectMenuItem);
export { factory as menuFactory };
export default Menu;
export { Menu };
